import { createSelector } from '@ngrx/store';

export const commentAndPageCommentLoading = createSelector(
  state => state['comment']?.isLoading,
  state => state['pageComment']?.isLoading,
  (commentsLoading: boolean, pageCommentsLoading: boolean) => commentsLoading || pageCommentsLoading
);
